import { Div, P, Td, Tooltip, Tr } from '@dnb/eufemia';
import { Field, Form, Value } from '@dnb/eufemia/extensions/forms';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ApiType } from '@portals/shared/portal/ApiDto';

import { apiOrEvent } from '@/utils/integrationServiceUtils';

const InlineFieldWrapper = styled(Div)`
  display: inline-block;

  .dnb-checkbox__button {
    ${({ warnHighlight }: { warnHighlight: boolean }) =>
      warnHighlight &&
      css`
        border: 2px solid var(--color-accent-yellow);
      `}
  }
`;

type ScopeEnvSelectItemProps = {
  itemIndex: number;
  liveAccessEnabled: boolean;
  initiallyHadLiveAccess: boolean;
  apiType: ApiType;
};

export default function ScopeEnvSelectItem({
  itemIndex,
  liveAccessEnabled,
  initiallyHadLiveAccess,
  apiType,
}: ScopeEnvSelectItemProps) {
  const { update, getValue } = Form.useData();

  const testScopeChanged = (value: boolean) => {
    if (!value) {
      update(`/scopes/${itemIndex}/live`, false);
    }
  };
  const liveScopeChanged = (value: boolean) => {
    if (value) {
      update(`/scopes/${itemIndex}/test`, true);
    }
  };

  const shouldDisableLiveCheckbox = !liveAccessEnabled && !initiallyHadLiveAccess;

  return (
    <Tr>
      <Td>
        <P style={{ margin: 0 }} weight="medium">
          <Value.String itemPath="/name" />
        </P>
        <P style={{ margin: 0 }}>
          <Value.String itemPath="/description" />
        </P>
      </Td>
      <Td>
        <InlineFieldWrapper>
          <Field.Boolean itemPath="/test" label="" onChange={(val) => testScopeChanged(val as boolean)} />
        </InlineFieldWrapper>
      </Td>
      <Td>
        <InlineFieldWrapper
          warnHighlight={!liveAccessEnabled && initiallyHadLiveAccess && !getValue(`/scopes/${itemIndex}/live`)}
        >
          <Field.Boolean
            className={`liveScopeCheckbox-${itemIndex}`}
            disabled={shouldDisableLiveCheckbox}
            itemPath="/live"
            label=""
            onChange={(val) => liveScopeChanged(val as boolean)}
          />
        </InlineFieldWrapper>
        {shouldDisableLiveCheckbox && (
          <Tooltip targetSelector={`.liveScopeCheckbox-${itemIndex}`}>
            Live access requests are not enabled for this {apiOrEvent(apiType)}.
          </Tooltip>
        )}
      </Td>
    </Tr>
  );
}
